import * as React from "react";
import { Show, SimpleShowLayout, TextField } from 'react-admin';
const ShopKeywordDetail = ({...props }) => (

    <Show title="Keyword Detail" {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="keyword" label="Keyword" />
            <TextField source="status" label="Status" />
            <TextField source="icon" label="Icon" />
            <TextField source="descripton" label="Description" />
        </SimpleShowLayout>
    </Show>
     );
export default ShopKeywordDetail